import React from 'react';
import PendoScript from './PendoScript';
import FacebookScript from './FacebookScript';
import ConvertExperimentsScript from './ConvertExperimentsScript';
import NewRelicScript from './NewRelicScript';
import AdobeAnalyticsScript from './AdobeAnalyticsScript';
import type { AdobeAnalyticsUser } from '../../../lib/util/adobeAnalytics';

type Props = {
  pathname?: string | null;
  asPath?: string;
  user?: AdobeAnalyticsUser | null;
};

/**
 * Scripts.
 */
const Scripts = ({ pathname = '', asPath = '', user }: Props) => {
  return (
    <>
      <NewRelicScript />
      <FacebookScript />
      <PendoScript />
      <ConvertExperimentsScript asPath={asPath} />
      <AdobeAnalyticsScript asPath={asPath} pathname={pathname} user={user} />
    </>
  );
};

export default Scripts;
